import Vue from 'vue'
import axios from '@/wrappers/axios.js'

const AppService = {

    appList(params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/applications${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    createApp(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/applications`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    getApp(id, params) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/applications/${id}${params ? params : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    updateApp(id, data) {
        return new Promise(async (resolve, reject) => {
            axios
                .put(`/applications/${id}`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    delete(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .delete(`/applications/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
    attachUser(data) {
        return new Promise(async (resolve, reject) => {
            axios
                .post(`/applications/attach-user`, data)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },

    isUp(id) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(`/applications/${id}/is-up`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(e => reject(e));
        })
    },
}

Vue.$appService = AppService

export default AppService